<script setup lang="ts">
import { PaymentsEmbed } from '@/Pejer/tables/Payments'
import PaymentRefundContentView from '@/views/Payments/PaymentRefundView/PaymentRefundContentView.vue'
import { ArrowRight } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from 'pejer/src/components/ui/dialog'
import { ref } from 'vue'

defineProps<{
  payment: PaymentsEmbed.ListItem
}>()

const isOpen = ref(false)
</script>
<template>
  <Dialog :open="isOpen" @update:open="isOpen = $event">
    <DialogTrigger as-child>
      <slot>
        <Button
          @click.prevent.stop
          variant="ghost"
          class="p-1 h-6 hover:bg-gray-200 rounded-sm group text-gray-600"
        >
          <ArrowRight class="group-hover:scale-110" :size="16" />
        </Button>
      </slot>
    </DialogTrigger>
    <DialogContent
      class="w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-20px)] h-fit flex flex-col gap-0 overflow-y-scroll"
    >
      <DialogTitle class="flex-1"
        ><div>
          <h2 class="text-lg font-semibold mb-2">
            <span class="text-muted-foreground text-sm">{{ payment.customer?.name }}</span>
            <span class="flex gap-2 items-center"> {{ payment.description }}</span>
          </h2>
        </div>
      </DialogTitle>
      <DialogDescription class="flex-1 text-muted-foreground text-xs mb-6">
        Her kan du refundere, godkjenne eller endre fakturabeløpet for betalingen
      </DialogDescription>
      <PaymentRefundContentView
        :paymentReferenceID="payment.paymentReferenceID"
        @close="isOpen = false"
      />
    </DialogContent>
  </Dialog>
</template>
